import React from "react";

const Flow = () => {
     return <div>Flow</div>;
};

export default Flow;
